import { useState, useCallback, useEffect } from "react";
import useInterval from "./useInterval";

const useCountdown = (
  onCountdownEnd: () => void,
  timeEnd: number | undefined,
  countdownEnabled: boolean
) => {
  const getTimeLeft = useCallback(
    () =>
      timeEnd
        ? Math.round(
            (new Date(timeEnd).getTime() - new Date().getTime()) / 1000
          )
        : undefined,
    [timeEnd]
  );
  const [timeLeft, setTimeLeft] = useState<number | undefined>(getTimeLeft());
  const [done, setDone] = useState(false);

  const updateTimeLeft = useCallback(
    () => !done && setTimeLeft(getTimeLeft()),
    [done, getTimeLeft]
  );
  useInterval(updateTimeLeft, 1000, countdownEnabled, [
    countdownEnabled,
    updateTimeLeft,
  ]);
  useEffect(() => {
    if (timeLeft !== undefined && timeLeft <= 0) {
      onCountdownEnd();
      setDone(true);
      setTimeLeft(undefined);
    }
  }, [timeLeft, onCountdownEnd]);
  return timeLeft;
};

export default useCountdown;
